// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
	//console.log($w("#memberLoginButton1").type);
	//$w("#memberLoginButton1").
});